export default __webpack_public_path__ + "static/topic8-0f091ebcf327f2793ba1da157997f810.png";